export function computeScores(alternatives, weights) {
  const keys = Object.keys(weights);
  const total = keys.reduce((s, k) => s + Math.max(0, Number(weights[k]) || 0), 0);
  const norm = {};
  keys.forEach((k) => {
    norm[k] = total > 0 ? Math.max(0, Number(weights[k]) || 0) / total : 1 / (keys.length || 1);
  });
  const out = {};
  (alternatives || []).forEach((a) => {
    const fmap = {};
    (a.factor_scores || []).forEach((f) => (fmap[f.criterion_id] = Number(f.score)));
    let s = 0;
    keys.forEach((k) => (s += norm[k] * (fmap[k] ?? 50)));
    out[a.id] = Math.round(s * 10) / 10;
  });
  return out;
}
